export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.getElementById(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-background-950 pt-14 md:pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-black tracking-tight" style={{ color: 'oklch(var(--foreground-50))' }}>
              91视频
            </span>
            <p className="text-sm mt-3 leading-relaxed" style={{ color: 'oklch(var(--foreground-300))' }}>
              91视频网站专注国产影视内容，提供91国产视频、国产电视剧、电影和综艺节目的免费在线观看服务。每日更新，高清流畅。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4" style={{ color: 'oklch(var(--foreground-100))' }}>快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '移动客户端', href: 'app' },
                { label: '片库索引', href: 'index' },
                { label: '最新动态', href: 'updates' },
                { label: '常见问题', href: 'faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={`#${link.href}`}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="text-sm no-underline transition-colors cursor-pointer"
                  style={{ color: 'oklch(var(--foreground-400))' }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4" style={{ color: 'oklch(var(--foreground-100))' }}>内容分类</h4>
            <div className="flex flex-col gap-2.5">
              {['91年国产电影', '国产电视剧', '国产综艺', '纪录片频道'].map((cat) => (
                <span key={cat} className="text-sm cursor-pointer" style={{ color: 'oklch(var(--foreground-400))' }}>
                  {cat}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4" style={{ color: 'oklch(var(--foreground-100))' }}>联系我们</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm" style={{ color: 'oklch(var(--foreground-400))' }}>
                <i className="ri-mail-line mr-2" style={{ color: 'oklch(var(--primary-400))' }}></i>
                contact@91video.com
              </span>
              <span className="text-sm" style={{ color: 'oklch(var(--foreground-400))' }}>
                <i className="ri-wechat-line mr-2" style={{ color: 'oklch(var(--primary-400))' }}></i>
                官方公众号
              </span>
              <span className="text-sm" style={{ color: 'oklch(var(--foreground-400))' }}>
                <i className="ri-question-answer-line mr-2" style={{ color: 'oklch(var(--primary-400))' }}></i>
                在线反馈
              </span>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t" style={{ borderColor: 'oklch(var(--foreground-800))' }}>
          <h4 className="text-xs font-semibold mb-3" style={{ color: 'oklch(var(--foreground-200))' }}>
            合作伙伴
          </h4>
          <p className="text-xs mb-6" style={{ color: 'oklch(var(--foreground-500))' }}>
            更多合作品牌即将入驻，敬请期待
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs" style={{ color: 'oklch(var(--foreground-500))' }}>
              &copy; 2026 91视频网站. 本站内容仅供学习交流使用
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs cursor-pointer" style={{ color: 'oklch(var(--foreground-500))' }}>
                用户协议
              </span>
              <span className="text-xs cursor-pointer" style={{ color: 'oklch(var(--foreground-500))' }}>
                隐私政策
              </span>
              <span className="text-xs cursor-pointer" style={{ color: 'oklch(var(--foreground-500))' }}>
                版权声明
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}